export default __webpack_public_path__ + "static/media/cash.aabd801a.svg";